var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-wheel",class:{ rotate: _vm.rotate },style:(_vm.wheelStyle)})}
var staticRenderFns = []

export { render, staticRenderFns }